import { takeEvery } from 'redux-saga/effects';
import { POST_AVAILABLE_USER } from './action-types';
import { postAvailableUserSaga } from './sagas';

export default function* watchers() {
  yield takeEvery(POST_AVAILABLE_USER, postAvailableUserSaga);
}
